export enum ActivityNotificationType {

  ACTIVITY = 'activity',
  NOTIFICATION = 'notification'

}


export enum ActivityNotificationAction {

  UPDATE_USER_DATA = 'update_user_data',
  ADD_WEBSITE = 'add_website',
  CREATE_WEBSITE = 'create_website',
  CREATE_STAGING_WEBSITE = 'staging_website_create',
  DELETE_STAGING_WEBSITE = 'staging_website_delete',
  GENERATE_WEBSITE_SCREENSHOT = 'generate_website_screenshot',
  CLIENT_LOGOUT_EXCEPT_CURRENT_SESSION = 'client_logout_except_current_session',
  CLIENT_LOGOUT = 'client_logout',
  REMOVE_WEBSITE = 'remove_website',
  DEACTIVATE_WEBSITE = 'deactivate_website',
  MIGRATE_WEBSITE = 'migrate_website',
  UPDATE_WEBSITE_WORDPRESS_VERSION = 'wp_core_update',
  INSTALL = 'install',
  INSTALL_ACTIVATE = 'install_activate',
  UPDATE = 'update',
  DELETE = 'delete',
  DEACTIVATE_DELETE = 'deactivate_delete',
  ACTIVATE = 'activate',
  DEACTIVATE = 'deactivate',
  RUN_JOB = 'run_job',
  RESTORE = 'restore',
  PROCESS_DOWNLOAD = 'process_download',
  OPTIMIZE = 'optimize',
  PERFORMANCE_CHECK = 'performance_check',
  SECURITY_SCAN = 'run_scan',
  WORKSPACE_ROLE_EDIT = 'workspace_role_edit',
  WORKSPACE_LEAVE = 'workspace_leave',
  WORKSPACE_CLIENT_REMOVE = 'workspace_client_remove',

}

export enum ActivityNotificationStatus {

  PENDING = 'pending',
  RUNNING = 'running',
  DONE = 'done',
  FAILED = 'failed',
  CANCELED = 'canceled'

}

export interface IActivityNotification {

  id: string;
  websiteId: number;
  service: string;
  type: string;
  action: string;
  date: Date;
  isNew: boolean;
  status: string;
  message: string;
  progress: number;
  meta: any;

}
